export default [
    {
        text: 'Please select print size',
        value: null
    },
    {
        text: '21-up labels 63.5 mm x 38.1 mm on A4',
        value: {
            width: 63.5,
            height: 38.1,
            pageSize: 'A4'
        }
    },
    {
        text: '24-up labels 63.5 mm x 33.9 mm on A4',
        value: {
            width: 63.5,
            height: 33.9,
            pageSize: 'A4'
        }
    },
    {
        text: '24-up labels 64.6 mm x 33.8 mm on A4',
        value: {
            width: 64.6,
            height: 33.8,
            pageSize: 'A4'
        }
    },
    {
        text: '24-up labels 66.0 mm x 33.9 mm on A4',
        value: {
            width: 66,
            height: 33.9,
            pageSize: 'A4'
        }
    },
    {
        text: '24-up labels 66.0 mm x 35.0 mm on A4',
        value: {
            width: 66,
            height: 35,
            pageSize: 'A4'
        }
    },
    {
        text: '24-up labels 70.0 mm x 36.0 mm on A4',
        value: {
            width: 70,
            height: 36,
            pageSize: 'A4'
        }
    },
    {
        text: '24-up labels 70.0 mm x 37.0 mm on A4',
        value: {
            width: 70,
            height: 37,
            pageSize: 'A4'
        }
    },
    {
        text: '27-up labels 63.5 mm x 29.6 mm on A4',
        value: {
            width: 63.5,
            height: 29.6,
            pageSize: 'A4'
        }
    },
    {
        text: '30-up labels 1" x 2-5/8" on US Letter',
        value: {
            width: 66.675,
            height: 25.4,
            pageSize: 'Letter'
        }
    },
    {
        text: '40-up labels 52.5 mm x 29.7 mm on A4',
        value: {
            width: 63.5,
            height: 33.9,
            pageSize: 'A4'
        }
    },
    {
        text: '44-up labels 48.5 mm x 25.4 mm on A4',
        value: {
            width: 48.5,
            height: 25.4,
            pageSize: 'A4'
        }
    }
]



// WEBPACK FOOTER //
// ./src/assets/js/print-options.js